import { render, staticRenderFns } from "./Paperclip.vue?vue&type=template&id=2e471976"
import script from "./Paperclip.vue?vue&type=script&lang=js"
export * from "./Paperclip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports